module.exports = __webpack_public_path__ + "static/media/lascalles02_medium@2x.65221458.jpg";